// Align the menu with the full search row, including after viewport changes.
(() => {
  const menu = document.querySelector('#header .mobile-menu');
  const search = document.querySelector('#header .head-slot-mid');
  if (!menu || !search) return;

  function positionMenu() {
    if (window.innerWidth >= 990 || !menu.offsetParent) return;
    const top = search.getBoundingClientRect().top - 12;
    const parentTop = menu.offsetParent.getBoundingClientRect().top;
    menu.style.setProperty('--mobile-menu-top', `${top - parentTop}px`);
    menu.style.setProperty('--mobile-menu-viewport-top', `${Math.max(0, top)}px`);
  }

  document.addEventListener('mobile-menu:open', positionMenu);
  window.addEventListener('resize', positionMenu);
  window.visualViewport?.addEventListener('resize', positionMenu);
})();
